import type { ReactNode } from 'react';

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-paper px-4 py-10">
      <div className="mb-6 text-lg font-bold tracking-tight text-ink">
        Remind<span className="text-accent-500">Me</span>Voice
      </div>
      <div className="w-full max-w-md rounded-2xl border border-paper-border bg-white p-8 shadow-card">
        <h1 className="text-2xl font-medium text-ink">{title}</h1>
        {subtitle && <p className="mt-2 text-sm leading-relaxed text-ink-soft">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}

export function Divider({ label = 'or' }: { label?: string }) {
  return (
    <div className="my-4 flex items-center gap-3 text-xs text-ink-muted">
      <div className="h-px flex-1 bg-paper-border" />
      <span>{label}</span>
      <div className="h-px flex-1 bg-paper-border" />
    </div>
  );
}
